const VAT = 1.22;

export default function calculateSaving(propertyValue: number, fee: number) {
  return (propertyValue * fee * VAT) / 100;
}
